<script>
  import Wysiwyg from './Wysiwyg.svelte';

  export let first;
  export let second;
</script>

<div class="two-columns">
  <div class="flexbox">
    <div class="col col-50 col-s-full two-columns__first">
      <Wysiwyg content={first} />
    </div>
    <div class="col col-50 col-s-full two-columns__second">
      <Wysiwyg content={second} />
    </div>
  </div>
</div>

<style lang="scss">
  .two-columns {
    margin: 8rem auto;

    @include resp-max('s') {
      margin: 4rem auto;
    }

    .flexbox {
      margin: 0 -4rem;

      & > .col {
        padding: 0 4rem;
      }
    }
  }
</style>
